import React, { useState, useEffect } from "react";
// @material-ui/core components
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Pagination from "@material-ui/lab/Pagination";
import { makeStyles } from "@material-ui/core/styles";
// core components
import { connect } from "react-redux";
import {
  getMenus as getCategoryList,
  getOrderList,
  getOrderListForDownload,
  // getAllDeliveryBoys
} from "../../store/actions/admin/Admin";
import CardHeader from "../../components/Card/CardHeader.js";
import OrderItemCard from "../../components/Common/OrderItemCard.js";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@material-ui/core";
import { ORDER_STATUS } from "../../utils/constant.js";
import BackDrop from "../../components/User/Preloader/BackDrop";
import GlobalSearch from "../../components/Common/GlobalSearch";
import CsvDownload from "react-json-to-csv";
import TextField from "@material-ui/core/TextField";
import { CloudDownloadOutlined, Flight } from "@material-ui/icons";
import DateRangePicker from "react-bootstrap-daterangepicker";
// you will need the css that comes with bootstrap@3. if you are using
// a tool like webpack, you can do the following:
import "bootstrap/dist/css/bootstrap.css";
// you will also need the css that comes with bootstrap-daterangepicker
import "bootstrap-daterangepicker/daterangepicker.css";
import GridItem from "../../components/Grid/GridItem.js";
import GridContainer from "../../components/Grid/GridContainer.js";
import KiwiFlightOrderCard from "../../components/User/MyOrders/components/FlighOrder/KiwiFlightOrderCard";
import GoFlySmartFlightOrderCard from "../../components/User/MyOrders/components/FlighOrder/GoFlySmartFlightOrderCard";
import AiriqFlightOrderCard from "../../components/User/MyOrders/components/FlighOrder/AiriqFlightOrderCard";
import TboOrderCard from "../../components/User/MyOrders/components/FlighOrder/TboOrderCard";

const userLoginType = localStorage.getItem("userLoginType") || "";
const styles = {
  wrapper: {
    minHeight: "200px",
    backgroundColor: "white",
    borderRadius: "10px",
    margin: "0 auto",
    boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
    transition: "0.3s",
    marginTop: "10px",
    padding: "0px 10px",
  },
  cardTitle: {
    color: "#FFFFFF",
    paddingTop: "10px",
  },
  label: {
    color: "#FFFFFF",
    fontSize: "16px",
    padding: "5px 0px",
  },
  p5: {
    padding: 5,
  },
  mt5: {
    marginTop: 5,
  },
  formComponent: {
    fontSize: "14px",
    color: "#fff",
    border: "#fff",
    borderRadius: 5,
    height: "35px",
  },
  formInput: {
    fontSize: "16px",
    color: "black",
    border: "#fff",
    borderRadius: 20,
    marginLeft: "5px",
    padding: "3px 10px",
    maxWidth: "155px",
  },
};

const useStyles = makeStyles(styles);
const PAGE_LIMIT = 2000;
var update = false;
const OrdersTableList = (props) => {
  const classes = useStyles();
  const api_progress = props.api_progress;
  const [pageNo, updatePageNo] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  useEffect(() => {
    // props.getCategoryList();
    props.getOrderList(-1, pageNo);
    //props.getAllDeliveryBoys();
  }, [update]);
  const { className } = props;
  const [modal, setModal] = useState(false);
  const [modal2, setModal2] = useState(false);
  const [dropPhone, setDropPhone] = useState("");
  const [placedBy, setPlacedBy] = useState("");
  const [orderStatus, updateStatus] = useState(-1);
  const [orderType, updateOrderType] = useState("ALL_TYPE");

  const toggle = () => setModal(!modal);
  const toggle2 = () => setModal2(!modal2);

  const [itemDelete, setItemDelete] = useState(0);
  const handleEvent = (event, picker) => {};
  const handleCallback = (start, end, label) => {
    setStartDate(start.tz("Australia/Sydney").startOf("day"));
    setEndDate(end.tz("Australia/Sydney").startOf("day"));
    props.getOrderList(
      orderStatus,
      undefined,
      searchText,
      orderType,
      start?.tz("Australia/Sydney").startOf("day").valueOf(),
      end?.tz("Australia/Sydney").startOf("day").valueOf()
    );
    updatePageNo(1);
  };

  const handleDelete = (menuId) => {
    props.deleteMenu(menuId);
    if (update === false) {
      update = true;
      setTimeout(() => {
        update = false;
      }, 2500);
    } else {
      update = true;
      update = false;
    }
  };

  const handleChangeOrderStatus = (e) => {
    props.getOrderList(e.target.value).then((data) => {
      if (data) {
        updateStatus(e.target.value);
        updatePageNo(1);
      }
    });
  };

  const handleOrderTypeChange = (e) => {
    updateOrderType(e.target.value);
    props.getOrderList(
      orderStatus,
      undefined,
      searchText,
      e.target.value,
      startDate?.valueOf(),
      endDate?.valueOf(),
      dropPhone,
      placedBy
    );
    updatePageNo(1);
  };

  const handlePagination = (e, page) => {
    updatePageNo(page);
    props.getOrderList(
      orderStatus,
      page,
      searchText,
      orderType,
      startDate?.valueOf(),
      endDate?.valueOf(),
      dropPhone,
      placedBy
    );
  };
  const handleSearchSubmit = () => {
    props.getOrderList(
      orderStatus,
      undefined,
      searchText,
      orderType,
      startDate?.valueOf(),
      endDate?.valueOf(),
      dropPhone,
      placedBy
    );
    updatePageNo(1);
  };

  const handleDropPhoneChange = (e) => {
    setDropPhone(e.target.value);
    props.getOrderList(
      orderStatus,
      undefined,
      searchText,
      orderType,
      startDate?.valueOf(),
      endDate?.valueOf(),
      e.target.value,
      placedBy
    );
    updatePageNo(1);
  };

  const handlePlacedByChange = (e) => {
    setPlacedBy(e.target.value);
    props.getOrderList(
      orderStatus,
      undefined,
      searchText,
      orderType,
      startDate?.valueOf(),
      endDate?.valueOf(),
      dropPhone,
      e.target.value
    );
    updatePageNo(1);
  };
  const JSONToCSVConvertor = (ReportTitle, ShowLabel) => {
    props
      .getOrderListForDownload(
        orderStatus,
        searchText,
        orderType,
        startDate?.valueOf(),
        endDate?.valueOf(),
        dropPhone,
        placedBy
      )
      .then((data) => {
        if (data) {
          const JSONData = data.data;
          //If JSONData is not an object then JSON.parse will parse the JSON string in an Object
          var arrData =
            typeof JSONData !== "object" ? JSON.parse(JSONData) : JSONData;

          var CSV = "";

          //This condition will generate the Label/Header
          if (ShowLabel) {
            var row =
              "Order Ref No,Price,Distance,Placed On,No Of Packages,PickUp Phone Number,Pickup Building Number,PickUp Address,Drop Phone Number,Drop Building Number,Drop Address,Placed By,Status" +
              ",";
            row.slice(0, row.length - 1);
            //append Label row with line break
            CSV += row + "\r\n";
          }

          //1st loop is to extract each row
          for (var i = 0; i < arrData.length; i++) {
            var row = "";

            row += '"' + arrData[i]["orderRef"] + '",';
            row += '"' + arrData[i]["totalPrice"] + '",';
            row +=
              '"' +
              (arrData[i]["distance"]
                ? arrData[i]["distance"]
                : "Not Available") +
              '",';
            row +=
              '"' + new Date(arrData[i]["createdAt"])?.toLocaleString() + '",';
            row +=
              '"' +
              (arrData[i]["noOfPackages"] ? arrData[i]["noOfPackages"] : "") +
              '",';
            row += '"' + arrData[i].pickUpAddress?.["phone_number"] + '",';
            row += '"' + arrData[i].pickUpAddress?.["building_number"] + '",';
            row += '"' + arrData[i].pickUpAddress?.["street"] + '",';
            row += '"' + arrData[i].dropAddress?.["phone_number"] + '",';
            row += '"' + arrData[i].dropAddress?.["building_number"] + '",';
            row += '"' + arrData[i].dropAddress?.["street"] + '",';
            row += '"' + arrData[i]["userDetails"][0]["phone_number"] + '",';
            row += '"' + arrData[i]["status"] + '",';

            row.slice(0, row.length - 1);

            //add a line break after each row
            CSV += row + "\r\n";
          }

          if (CSV === "") {
            alert("Invalid data");
            return;
          }

          //Generate a file name
          var fileName = "Report_";
          //this will remove the blank-spaces from the title and replace it with an underscore
          fileName += ReportTitle.replace(/ /g, "_");

          //Initialize file format you want csv or xls
          var uri = "data:text/csv;charset=utf-8," + escape(CSV);

          // Now the little tricky part.
          // you can use either>> window.open(uri);
          // but this will not work in some browsers
          // or you will not get the correct file extension

          //this trick will generate a temp <a /> tag
          var link = document.createElement("a");
          link.href = uri;

          //set the visibility hidden so it will not effect on your web-layout
          link.style = "visibility:hidden";
          link.download = fileName + ".csv";

          //this part will append the anchor tag and remove it after automatic click
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      });
  };

  function getFlightCard(item) {
    let FlightCard = KiwiFlightOrderCard;
    switch (item.flightVendorType) {
      case "airiq":
        FlightCard = AiriqFlightOrderCard;
        break;
      case "tbo":
        FlightCard = TboOrderCard;
        break;
      default:
        FlightCard = KiwiFlightOrderCard;
    }

    return <FlightCard {...props} order={item} userLoginType={userLoginType} />;
  }

  return (
    <>
      <BackDrop open={api_progress}></BackDrop>
      <CardHeader
        style={{
          backgroundImage: "linear-gradient(45deg,#FBA51C,#5AAE5E)",
          borderRadius: 10,
        }}
      >
        <GridContainer>
          <GridItem xs={12} sm={12} md={2}>
            <h4 className={classes.cardTitle}>All Orders</h4>
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <FormControl className={classes.formControl}>
              <GlobalSearch
                width={"320px"}
                onChange={(event) => {
                  setSearchText(event.target.value);
                }}
                title={"Search Order By Order Ref No"}
                handleSubmit={handleSearchSubmit}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6} className={classes.mt5}>
            <GridContainer>
              <GridItem xs={12} sm={12} md={3}>
                <Typography
                  className={`${classes.label} ${classes.p5} ${classes.mt5}`}
                >
                  {" "}
                  Status
                </Typography>
              </GridItem>
              <GridItem xs={12} sm={12} md={4}>
                <FormControl fullWidth>
                  <Select
                    variant="outlined"
                    sx={{ m: 1, minWidth: 60 }}
                    className={`${classes.mt5} ${classes.formComponent} `}
                    id="demo-controlled-open-select"
                    value={orderStatus}
                    onChange={handleChangeOrderStatus}
                  >
                    {ORDER_STATUS?.map((item) => (
                      <MenuItem value={item?.value}>{item?.label}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </GridItem>
              <GridItem xs={12} sm={12} md={5}>
                <Select
                  variant="outlined"
                  className={`${classes.mt5} ${classes.formComponent} `}
                  labelId="demo-controlled-open-select-label"
                  id="demo-controlled-open-select"
                  value={orderType}
                  onChange={handleOrderTypeChange}
                >
                  <MenuItem value={"ALL_TYPE"}>{"All Type Order"}</MenuItem>
                  <MenuItem value={"PICK_DROP"}>{"Pick and Drop"}</MenuItem>
                  <MenuItem value={"NORMAL_ORDER"}>{"Normal Order"}</MenuItem>
                </Select>
              </GridItem>
            </GridContainer>
          </GridItem>
        </GridContainer>

        <GridContainer>
          <GridItem md="2"></GridItem>
          <GridItem md="4">
            <GridContainer>
              <GridItem md="6" style={{ padding: "0px !important" }}>
                {/* <TextField variant="outlined"  margin="dense" size="small"  className={`${classes.mt5} ${classes.formComponent} `}   fullWidth type="text" placeholder="Drop Phone" value={dropPhone} style={{padding:'5px 0px !important'}}   onChange={handleDropPhoneChange} /> */}
                <input
                  className={`${classes.mt5} ${classes.formInput} `}
                  type="text"
                  placeholder="Drop Phone"
                  value={dropPhone}
                  style={{ padding: "5px 0px !important" }}
                  onChange={handleDropPhoneChange}
                />
              </GridItem>
              <GridItem md="6" style={{ padding: "0px !important" }}>
                {/* <TextField variant="outlined"   margin="dense" size="small" className={`${classes.mt5} ${classes.formComponent} `}   fullWidth type="text" placeholder="Placed By" value={placedBy}  style={{padding:'5px 0px !important'}}  onChange={handlePlacedByChange}/> */}
                <input
                  className={`${classes.mt5} ${classes.formInput} `}
                  type="text"
                  placeholder="Placed By"
                  value={placedBy}
                  style={{ padding: "5px 0px !important" }}
                  onChange={handlePlacedByChange}
                />
              </GridItem>
            </GridContainer>
          </GridItem>
          <GridItem md="6">
            <GridContainer>
              <GridItem md="7">
                <div
                  className={classes.formInput}
                  style={{
                    backgroundColor: "#fff",
                    borderRadius: "20px",
                    height: "30px",
                    marginTop: "5px",
                    maxWidth: "280px",
                  }}
                >
                  <DateRangePicker
                    onEvent={handleEvent}
                    onCallback={handleCallback}
                  >
                    <TextField
                      InputProps={{ disableUnderline: true }}
                      fullWidth
                      type="text"
                      placeholder="Daterange"
                      value={
                        startDate
                          ? (startDate ? startDate.format("DD/MM/YYYY") : "") +
                            "-" +
                            (endDate ? endDate.format("DD/MM/YYYY") : "")
                          : ""
                      }
                    />
                  </DateRangePicker>
                </div>
              </GridItem>
              <GridItem xs="5">
                <div style={{ margin: "0px 15px" }}>
                  <Button
                    size="sm"
                    block
                    style={{ fontSize: "12px" }}
                    className={classes.mt5}
                    onClick={() => JSONToCSVConvertor("OrderReport", true)}
                  >
                    <CloudDownloadOutlined /> Download CSV
                  </Button>
                </div>
              </GridItem>
            </GridContainer>
          </GridItem>
        </GridContainer>
      </CardHeader>
      <div className="orderlist-light">
        {props?.orderList?.map((item) =>
          item.orderType === "FlightBooking" ? (
            <div className={classes.wrapper}>{getFlightCard(item)}</div>
          ) : (
            <OrderItemCard
              id={item.id}
              drivers={props.drivers}
              vendor={item?.vendorDetails[0]}
              address={item?.address}
              orderRef={item?.orderRef}
              user={item?.userDetails[0]}
              image={item?.vendorDetails[0]?.logo}
              isAdmin={true}
              driver={item?.driver}
              date={item?.createdAt}
              items={item?.orderDetails}
              price={item?.totalPrice}
              status={item.status}
              order={item}
            />
          )
        )}
      </div>
      <br></br>
      <br></br>
      <Pagination
        count={props.orderCount ? Math.ceil(props.orderCount / 10) : 1}
        color="primary"
        page={pageNo}
        onChange={handlePagination}
      />
      <Modal isOpen={modal} toggle={toggle} className={className}>
        <ModalHeader toggle={toggle}>Delete</ModalHeader>
        <ModalBody>Do you really want to delete this Menu??</ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={function (event) {
              handleDelete(itemDelete);
              toggle();
            }}
          >
            Delete
          </Button>{" "}
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={modal2} toggle={toggle2} className={className}>
        <ModalHeader toggle={toggle2}>Modify a Menu</ModalHeader>
        <ModalBody></ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={function (event) {
              handleDelete(itemDelete);
              toggle();
            }}
          >
            Delete
          </Button>{" "}
          <Button color="secondary" onClick={toggle2}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

const mapStateWithProps = (state) => ({
  menuItems: state.admin.menuItems,
  orderList: state.admin.orderList,
  orderCount: state.admin.orderCount,
  api_progress: state.admin.apiLoading,
  drivers: state.admin.allDrivers,
});
const mapDispatchWithProps = (dispatch) => {
  return {
    getCategoryList: () => dispatch(getCategoryList()),
    // getAllDeliveryBoys: () => dispatch(getAllDeliveryBoys(1, PAGE_LIMIT)),
    getOrderList: (
      id,
      pageNumber,
      orderRef,
      orderType,
      startTime,
      endTime,
      dropPhone,
      placedBy
    ) =>
      dispatch(
        getOrderList(
          id,
          pageNumber,
          orderRef,
          orderType,
          startTime,
          endTime,
          dropPhone,
          placedBy
        )
      ),
    getOrderListForDownload: (
      id,
      orderRef,
      orderType,
      startTime,
      endTime,
      dropPhone,
      placedBy
    ) =>
      dispatch(
        getOrderListForDownload(
          id,
          orderRef,
          orderType,
          startTime,
          endTime,
          dropPhone,
          placedBy
        )
      ),
  };
};

export default connect(
  mapStateWithProps,
  mapDispatchWithProps
)(OrdersTableList);
